import styled from "styled-components";
import { Card } from "components/common";

export const WrapperGrabbing = styled.div`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        cursor: pointer;
        gap: 10px;

        .img-box {
          display: flex;
          justify-content: center;
          align-items: center;
          height: ${props => props.isSmall ? "40px" : "50px"};
          width: ${props => props.isSmall ? "40px" : "50px"};
          background: white;
          border-radius: 5px;
          box-shadow: 0px 1px 5px #a1a0a0;

          img {
              height: ${props => props.isSmall ? "35px" : "45px"};
              width: ${props => props.isSmall ? "35px" : "45px"};
          }
      }

      .nameuser {
          font-size: 10px;
          color: black;
          font-weight: 500;
          text-transform: Captialize;
      }
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${props => props.isSmall ? "10px" : "20px"};
  min-height: 50px;
  border-width: 2px;
  border-style: solid;
  border-radius: 5px;
  width: ${props => props.isDragging ? "70px" : "100%"};
  padding: ${props => props.isSmall ? "5px" : "10px"};
  ${props => props.isDragging ? "border: none;" : ""}

  .updownbuttons {
    visibility: ${props => props.isDragging ? "hidden" : "visible"};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    height: 100%;
  }

  .user-profile {
    display: flex;
    flex-direction: ${props => props.isDragging ? "column" : "row"};
    justify-content: flex-start;
    align-items: center;
    gap: ${props => props.isSmall ? "10px" : "15px"};
    width: ${props => props.isSmall ? "130px" : "190px"};
    border-right: 1px solid #575656;
    ${props => props.isDragging ? "border: none;" : ""}

    .image {
      height: 40px;
      width: 40px;
      box-shadow: 0px 1px 5px #a1a0a0;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;

      img {
        height: 35px;
        width: 35px;
        border-radius: 5px;
      }
    }
    .username {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: ${props => props.isSmall ? "75px" : "130px"};
    }
  }

  .counter-input {
    visibility: ${props => props.isDragging ? "hidden" : "visible"};
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: ${props => props.isSmall ? "5px" : "10px"};
    .count-box {
      display: flex;
      justify-content: center;
      align-items: center;
      width: ${props => props.isSmall ? "18px" : "25px"};
      height: ${props => props.isSmall ? "18px" : "25px"};
      border-radius: 5px;
      color: white;
    }
  }

  .rotaion-text {
    visibility: ${props => props.isDragging ? "hidden" : "visible"};
    width: 100%;
    text-align: center;

    .text-sm-sss {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }

  .rotaion-check {
    visibility: ${props => props.isDragging ? "hidden" : "visible"};
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media only screen and (max-width: 360px) {
    .user-profile {
      gap: 5px;
    }
  }
  
`;
